import { useEffect, useState, forwardRef, ForwardRefRenderFunction, InputHTMLAttributes } from 'react';
import { InputBirthday, InputBirthdayLabel } from 'theme/theme';
import { calendar } from './wordings';

interface DateInputProps extends InputHTMLAttributes<HTMLInputElement> {
  isMinor?: boolean;
}

const DateInput: ForwardRefRenderFunction<HTMLInputElement, DateInputProps> = ({ type, isMinor, ...props }, ref) => {
  const [showMinorClass, setShowMinorClass] = useState(false);

  useEffect(() => {
    if (isMinor) {
      setShowMinorClass(true);
      const timer = setTimeout(() => {
        setShowMinorClass(false);
      }, 3000); 

      return () => clearTimeout(timer);
    }
  }, [isMinor]);

  return (
    <div className={`flex flex-col items-center justify-between agegate__input__container__${type}`}>
      <InputBirthday
        theme={undefined}
        ref={ref}
        name={type}
        type="tel"
        pattern="\d*"
        className={`text-center w-full bg-transparent text-4xl font-bold saira agegate__input agegate__input__${type} ${showMinorClass ? 'agegate__input__minor' : ''} transition-all`}
        maxLength={2}
        {...props}
      />
      <InputBirthdayLabel className="text-center text-sm saira agegate__input__title">
        {calendar[type as keyof typeof calendar]}
      </InputBirthdayLabel>
    </div>
  );
}

const DateInputWithRef = forwardRef(DateInput);

export default DateInputWithRef;
